// extracted by mini-css-extract-plugin
module.exports =  {"container":"e3afc254ff--container--vm7zz","title":"e3afc254ff--title--nZClR","text":"e3afc254ff--text--Pt9Rt"};